// Module
var code = "<div class=\"row table-row no-margin\"> <span class=\"column\" ng-click=\"ctrl.rowClick()\"> <img ng-src=\"{{ctrl.imageSrc()}}\"/> </span> <span class=\"column\" ng-click=\"ctrl.rowClick()\" ng-transclude></span> <span class=\"column\" ng-if=\"ctrl.showRemove\"><vsko-icon ng-click=\"ctrl.remove()\" icon=\"remove\"></vsko-icon></span> </div>";
// Exports
module.exports = code;